import type { ChakraProps } from "@chakra-ui/react";

export const menuButtonStyles = {
  span: {
    color: "primary.900",
  },
  ":hover": {
    span: {
      color: "primary.500",
    },
  },
} as ChakraProps["sx"];

export const accordionButtonStyles = {
  svg: { color: "primary.900" },
  _expanded: { color: "primary.500", svg: { color: "primary.500" } },
} as ChakraProps["sx"];
